/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'

import '../peyk.scss'

import { Link, useNavigate } from 'react-router-dom'

import peykLogo from '../../../assets/svg/PeykLogo.png'

import { DatePicker } from "zaman"
import { post } from '../../../services/https'

export default function index() {
  const token = localStorage.getItem('token')

  const [name, setName] = useState('')
  const [meliCode, setMeliCode] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [birthday, setBirthday] = useState('')
  const [education, setEducation] = useState('')
  const [certificate, setCertificate] = useState('')
  const [insurance, setIncurance] = useState('')
   
  const navigate = useNavigate()
  
  useEffect(() => {
    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
      }).then(response => {
        // console.log(response)
        if (response.data.message === 'احراز هویت با موفقیت انجام شد') {

        } else {
          navigate('/peyk')
        }
    }).catch(() => {
      navigate('/peyk')
    })

  post('/api/front/peyks/info', {
      'phoneNumber': localStorage.getItem('phoneNumber')
    }).then(response => {
      setName(response.data.data.name)
      setMeliCode(response.data.data.meliCode)
      setPhoneNumber(response.data.data.phoneNumber)
      setBirthday(response.data.data.birthday)
      setEducation(response.data.data.education)
      setCertificate(response.data.data.motorCertificate)
      setIncurance(response.data.data.motorInsurance)
    })
  }, [navigate, token])
  
  return (
    <div id='peyk'>
      <main className="countainer">
        <Link to='/peyk/dashboard' className='Logo' style={{ margin: '1em auto', display: 'block' }}>
          <img src={peykLogo} alt="peykLogo" />
        </Link>
        <section className='from'>
          <div className="form__item">
            <label htmlFor="">نام و نام خانوادگی :</label>
            <input type="text" defaultValue={name} placeholder='علی...' />
          </div>
          <div className="form__item">
            <label htmlFor="">کدملی :</label>
            <input type="text" defaultValue={meliCode} className='form__input--ltr' placeholder='556 ...' />
          </div>
          <div className="form__item">
            <label htmlFor="">شماره موبایل :</label>
            <input type="text" defaultValue={phoneNumber} className='form__input--ltr' placeholder='09 ...' />
          </div>
          <div className="form__item">
            <label htmlFor="">تاریخ تولد :</label>
            <input type="text" defaultValue={birthday} className='form__input--ltr' placeholder='09 ...' />
          </div>
          <div className="form__item">
            <label htmlFor="">تحصیلات :</label>
            <select name="" id="" value={education}>
              <option value="سیکل">سیکل</option>
              <option value="دیپلم">دیپلم</option>
              <option value="کاردانی">کاردانی</option>
              <option value="کارشناسی">کارشناسی</option>
              <option value="کارشناسی ارشد">کارشناسی ارشد</option>
            </select>
          </div>
          <div className="form__item--twice">
            <div>
              <label htmlFor="">گواهینامه :</label>
              <select name="" id="" value={certificate}>
                <option value="true">دارم</option>
                <option value="false">ندارم</option>
              </select>
            </div>
            <div>
              <label htmlFor="">بیمه موتور :</label>
              <select name="" id="" value={insurance}>
                <option value="true">دارم</option>
                <option value="false">ندارم</option>
              </select>
            </div>
          </div>
          {/* <div className="form__item">
            <label htmlFor="">آپلود کارت موتور :</label>
          </div> */}
          <div className="form__message">
            در صورت مغایرت با مدیریت در تماس باشید
          </div>
        </section>
        <section className='copyright--signUp'>
          قدرت گرفته از <Link to='https://ibills.ir'>Ibills</Link> ، توسعه توسط <Link to='https://ham-team.ir'>هم‌تیم</Link>
        </section>
      </main>
    </div>
  )
}
